'use client'
import { assertPackageVersion } from '@dynamic-labs/assert-package-version';
import { version } from '../package.js';
export { SolanaWalletConnector, isSolanaWallet } from '@dynamic-labs/solana-core';
export { InjectedWalletBase as SolanaInjectedConnector } from './injected/InjectedWalletBase.js';
export { SolanaWalletConnectors } from './SolanaWalletConnectors.js';
export { SolanaWalletConnectorsWithConfig } from './SolanaWalletConnectorsWithConfig/SolanaWalletConnectorsWithConfig.js';
export { isBackpackSolanaSigner } from './utils/isBackpackSolanaSigner.js';
export { isSignedMessage } from './utils/isSignedMessage.js';

/* eslint-disable @typescript-eslint/no-unused-vars */
assertPackageVersion('@dynamic-labs/solana', version);
